import React from 'react'
import SlideInstructionModel from '../../molecules/slide-instruction-model/slide-instruction-model'
import DescriptionPoint from '../../molecules/description-point/description-point'

import './info-cur-v.scss'
import useMediaQuery from '../../../utils/useMediaQuery'

const InfoCurV = ({ zone, setZone }) => {
  const isMobile = useMediaQuery()

  return (
    <div className='info-cur-v'>
      <h2 className='info-cur-v__title'> Visual <span /></h2>
      { !isMobile && (
      <SlideInstructionModel />

        )}
      <DescriptionPoint zone={zone} setZone={setZone} />

    </div>
  )
}

export default InfoCurV
